var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"candidate-counter",class:{ active: _vm.leftSidebar == 'compares', 'opacity-0': _vm.candidates.length == 0 }},[_vm._v(_vm._s(_vm.candidates.length))])}
var staticRenderFns = []

export { render, staticRenderFns }